/**
 * Platform detection.
 *
 * Returns where the React bundle is currently running so feature code can
 * branch (e.g. native shells must use StoreKit / Play Billing for in-app
 * subscriptions, per Apple and Google rules).
 *
 * Capacitor injects a global `Capacitor` object into the webview and sets
 * `window.Capacitor.isNativePlatform()` to true. We treat anything else as
 * `web`. Detection is synchronous and safe to call at module load.
 */
export type Platform = "web" | "ios" | "android";

interface CapacitorGlobal {
  isNativePlatform?: () => boolean;
  getPlatform?: () => string;
}

declare global {
  interface Window {
    Capacitor?: CapacitorGlobal;
  }
}

export function getPlatform(): Platform {
  if (typeof window === "undefined") return "web";
  const cap = window.Capacitor;
  if (!cap || typeof cap.isNativePlatform !== "function" || !cap.isNativePlatform()) {
    return "web";
  }
  const native = typeof cap.getPlatform === "function" ? cap.getPlatform() : "";
  if (native === "ios") return "ios";
  if (native === "android") return "android";
  return "web";
}

export function isNative(): boolean {
  const p = getPlatform();
  return p === "ios" || p === "android";
}
